import React, {useEffect, useState} from "react";
import {Button} from "primereact/button";
import {useNavigate} from "react-router-dom";
import CourseCardDraft from "../../../components/cards/courseCardDraft/CourseCardDraft";
import {CourseService} from "../../../service/CourseService";
import {Toolbar} from "primereact/toolbar";
import BreadcrumbThree from "../../../components/breadcrumb/breadcrumb-3";

const InstructorCourses = () => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const navigate = useNavigate();

    const service = new CourseService();


    useEffect(() => {
        // service.checkPage();
        service.taughtCourses().then(data => {
            setData(data);
        });
    }, []);

    return (
        <>
            <BreadcrumbThree title="Kurslar"/>
            <div className="container">
                <Toolbar end={<Button label="Yeni Kurs" loading={loading}
                                      onClick={() => navigate('/instructor/createCourse')} size="small"/>}
                         className="mt-2 mb-2"/>
                {/*<div className="flex justify-content-end flex-wrap mb-3">*/}
                {/*    <Button label="Yeni Kurs" loading={loading} onClick={() => navigate('/instructor/createCourse')} size="small"/>*/}
                {/*</div>*/}

                {data?.map((course, index) => (
                    <CourseCardDraft key={index} data={course}/>
                ))}
            </div>
        </>
    );
};

export default InstructorCourses;
